var map = {
	"./dev": [
		679,
		41
	],
	"./dev.ts": [
		679,
		41
	],
	"./local": [
		680,
		42
	],
	"./local.ts": [
		680,
		42
	],
	"./perf": [
		681,
		43
	],
	"./perf.ts": [
		681,
		43
	],
	"./prod": [
		682,
		44
	],
	"./prod.ts": [
		682,
		44
	],
	"./prodfunk": [
		683,
		45
	],
	"./prodfunk.ts": [
		683,
		45
	],
	"./prodzurich": [
		684,
		46
	],
	"./prodzurich.ts": [
		684,
		46
	],
	"./prodzurichaxa": [
		685,
		47
	],
	"./prodzurichaxa.ts": [
		685,
		47
	],
	"./stage": [
		686,
		48
	],
	"./stage.ts": [
		686,
		48
	],
	"./stagezurich": [
		687,
		49
	],
	"./stagezurich.ts": [
		687,
		49
	],
	"./stagezurichaxa": [
		688,
		50
	],
	"./stagezurichaxa.ts": [
		688,
		50
	],
	"./test": [
		689,
		51
	],
	"./test.ts": [
		689,
		51
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 980;
module.exports = webpackAsyncContext;